import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { BreakpointTrackerContext } from '@jutro/layout';
import { TranslatorContext } from '@jutro/locale';
import { Chevron } from '@jutro/components';
import { withValidation, validationPropTypes } from '@xengage/gw-portals-validation-react';
import UnderwritingIssues from 'gw-components-platform-react/UnderwritingIssues/UnderwritingIssues';
import QuoteTableAccordionCardIterableComponent from 'gw-components-platform-react/QuoteTableAccordionCardIterableComponent/QuoteTableAccordionCardIterableComponent';
import metadata from './EURenewalPremiumBoxComponent.metadata.json5';
import styles from './EURenewalPremiumBoxComponent.module.scss';

function selectMetadata(breakpoint) {
    const contentArray = metadata.componentContent.content;
    let metadataToRender = '';

    if (breakpoint === 'phone') {
        metadataToRender = contentArray.filter((item) => item.id !== 'desktopTable');
    } else {
        metadataToRender = contentArray.filter((item) => item.id !== 'phoneTable' && item.id !== 'mobileAccordionHeader');
    }

    const filteredMetdata = {
        ...metadata,
        componentContent: {
            content: metadataToRender
        }
    };

    return filteredMetdata;
}

class PremiumBoxComponent extends Component {
    static contextType = TranslatorContext;

    static propTypes = {
        onChangeSubmission: PropTypes.func,
        viewOnlyMode: PropTypes.bool,
        showMonthlyPaymentComponent: PropTypes.bool,
        ...validationPropTypes
    };

    static defaultProps = {
        onChangeSubmission: undefined,
        viewOnlyMode: false,
        showMonthlyPaymentComponent: true
    }

    state = {
        formData: {},
    };

    componentDidMount() {
        const {
            renewalVM,
            updateWizardData,
            viewOnlyMode
        } = this.props;

        if (_.get(renewalVM, 'lobData.personalUmbrella_EU.paperlessInd.value') === undefined && !viewOnlyMode) {
            _.set(renewalVM, 'lobData.personalUmbrella_EU.paperlessInd.value', false);
            updateWizardData(renewalVM);
        }
    }

    getTotalPremium() {
        const { renewalVM } = this.props;
        const offerings = _.get(renewalVM, 'lobData.personalUmbrella_EU.offerings.value[0]');

        if (offerings.paymentPlans) {
            const payPlans = _.get(renewalVM, 'lobData.personalUmbrella_EU.offerings.value[0].paymentPlans');
            const selectedPlan = _.filter(payPlans, (plan) => plan.isSelected);
            const totalPremium = selectedPlan[0]?.total?.amount;

            if (!totalPremium && totalPremium !== 0) {
                return undefined;
            }

            _.set(renewalVM, 'unverfiedPremium', totalPremium);

            return { currency: 'usd', amount: totalPremium };
        }

        return undefined;
    }

    writeValue = (value, path) => {
        const { formData } = this.state;

        _.set(formData, path, value);
        this.setState({ formData });
    };

    generateOverrides() {
        const {
            renewalVM,
            viewOnlyMode,
            authHeader,
            updateWizardData,
            showMonthlyPaymentComponent
        } = this.props;

        return {
            '@field': {
                // apply to all fields
                onValueChange: this.writeValue,
                readOnly: viewOnlyMode,
                showRequired: true,
                autoComplete: false
            },
            totalPremiumID: {
                value: !_.isNil(this.getTotalPremium())
                    ? this.getTotalPremium() : undefined
            },
            paymentOptionsID: {
                submissionVM: renewalVM,
                authHeader,
                updateWizardData,
                LOB: 'personalUmbrella_EU',
                viewOnly: viewOnlyMode
            },
            monthlyPaymentScheduleComponent: {
                quoteID: renewalVM.value.jobID,
                authHeader,
                transactionTotalAmount: renewalVM.totalCost?.value,
                changeInCost: renewalVM.transactionCost?.value,
                startDate: renewalVM.baseData.periodStartDate.value,
                endDate: renewalVM.baseData.periodEndDate.value,
                jobTypeCode: renewalVM.baseData.jobType.value.code,
                offerings: _.get(renewalVM, 'lobData.personalUmbrella_EU.offerings.value'),
                visible: showMonthlyPaymentComponent
            }
        };
    }

    renderClauseTable = (breakpoint) => {
        const {
            setComponentValidation, onChangeSubmission, renewalVM
        } = this.props;

        const { formData } = this.state;
        const dataForComponent = {
            ...formData,
            ..._.pick(this.props, ['columnData', 'tableData', 'modifiers']),
            ...renewalVM,
            totalPremium: this.getTotalPremium(),
        };

        const resolvers = {
            resolveClassNameMap: styles,
            resolveComponentMap: {
                chevron: Chevron,
                quotetableaccordioncarditerablecomponent: QuoteTableAccordionCardIterableComponent,
                underwritingissues: UnderwritingIssues
            },
            resolveCallbackMap: {
                onChangeSubmissionAndSync: this.changeSubmissionAndSync,
                onSyncCoverages: this.syncCoverages,
                onChangeSubmission,
            }
        };
        const generatedMetadata = selectMetadata(breakpoint);

        return (
            <ViewModelForm
                uiProps={generatedMetadata.componentContent}
                model={dataForComponent}
                overrideProps={this.generateOverrides(breakpoint)}
                onValueChange={this.writeValue}
                onValidationChange={setComponentValidation}
                callbackMap={resolvers.resolveCallbackMap}
                classNameMap={resolvers.resolveClassNameMap}
            />
        );
    }

    render() {
        return (
            <BreakpointTrackerContext.Consumer>
                {this.renderClauseTable}
            </BreakpointTrackerContext.Consumer>
        );
    }
}

export default withValidation(PremiumBoxComponent);
